// @flow

export const productionSaveType = Object.freeze({
  Place: 'Place',
  All: 'All',
});
